module.exports = __webpack_public_path__ + "77595e70af9674191aa430e7fcc3e5f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/adddiscount.png
// module id = 80
// module chunks = 0